const e = "styles-module__container___3EDlB", s = "styles-module__message___mg1CW", t = {
  container: e,
  message: s
};
export {
  e as container,
  t as default,
  s as message
};
